import React, { forwardRef, useEffect, useMemo, useState } from "react"
import { IconButton, InputAdornment, InputBase, TextField, Typography, Popover } from "@material-ui/core"
import { DetailWrapperOqt } from "../";
import { Error } from "@material-ui/icons";
import { useDrop } from "react-dnd";
import { ItemTypes } from "../flows/DialogNode";
import { emptyObject } from "../../../redux/utils";

export const TextOqt = React.memo(forwardRef((props, ref) => {

  const {name, autocomplete, initialValue, details = false, caption, formik, placeholder, type, inputType, autoFocus, disabled, style = emptyObject, inputProps = {}, multiline = false, rows = undefined, variant="outlined", size="medium", regExpAccept} = props;
  const error = formik && formik.errors[name];
  const hasError = Boolean(error);
  const [state, setState] = useState(() => ({inputValue: (formik.values && `${(formik.values[name] === null || formik.values[name] === undefined) ? "" : formik.values[name]}`) || initialValue || "", loaded: false, touched: false}));  
  const [timer, setTimer] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const InputComponent = useMemo(() => (variant === "standard") ? InputBase : TextField, [variant]);
  const re = useMemo(() => Boolean(regExpAccept) ? new RegExp(regExpAccept) : undefined, [regExpAccept]);

  const handlePopoverOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  
  const [{ isOver }, drop] = useDrop(() => ({
    accept: ItemTypes.LIBRARY_ITEM,
    drop: (x, y) => {
      setState(state => ({...state, inputValue: y.getItem().value, touched: true}))
    },
    collect: monitor => ({
      isOver: !!monitor.isOver(),
    }),
  }), [])

  useEffect(() => {
    setState(state => ({...state, loaded: true}));
    return () => clearTimeout(timer);
  }, [])
/*
  useEffect(() => {
    const value = formik.values[name];
    if (!re || (re && re.test(value))) {
      const newValue = inputType === "number" 
        ? (!!value ? parseInt(value) : "")
        : value;
      setState({...state, inputValue: newValue, touched: true});
    }
  }, [formik.values[name]])
*/
  useEffect(() => {
    if(state.loaded && state.touched){
      timer && clearTimeout(timer);
      setTimer(
        setTimeout(()=> {
          formik.setFieldValue(name, state.inputValue);
        }
      , 100));
    }
  }, [state.inputValue])

  if(details){
    return (
      <>
        <DetailWrapperOqt caption={caption}>{formik.values[name]}</DetailWrapperOqt>
      </>
    )
  }
   
  const handleInputChange = async (e) => {   
    //e.preventDefault(); 
    //console.log({targetvalue: e.target.value, inputValue, test: re.test(e.target.value), re});
    if (!re || (re && re.test(e.target.value))) {
      const newValue = inputType === "number" 
        ? (e.target.value ? parseInt(e.target.value) : "")
        : e.target.value;
      setState({...state, inputValue: newValue, touched: true});
    }
  }

  return (

    <div style={{ padding: 8, width: "100%" }} ref={drop}>
      {InputComponent && 
        <>
          <InputComponent
            autoComplete={autocomplete}
            inputRef={ref}
            rows={rows}
            multiline={multiline}
            autoFocus={autoFocus}
            fullWidth
            type={type}
            variant={variant}
            label={variant === "outlined" && caption}
            style={{ ...style }}
            placeholder={placeholder}
            value={state.inputValue}
            onChange={handleInputChange}
            error={hasError}
            helperText={size !== "small" && error}
            disabled={disabled} 
            inputProps={size !== "small" ? inputProps : {...inputProps, style: {...inputProps.style, padding: 0} }}
            size={size} 
            spellCheck={false}
            endAdornment={variant === "standard" && error && 
              <InputAdornment  position="end">
                <IconButton onClick={handlePopoverOpen}>
                  <Error style={{fill: "orange"}}/>
                </IconButton>
              </InputAdornment>  
            }
          />
          <Popover
            open={open}
            anchorEl={anchorEl}
            onClose={handlePopoverClose}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'center',
            }}
            disableRestoreFocus
          >
            <Typography style={{maxWidth:240, padding: 4}}>{error}</Typography>
          </Popover>
        </>
      }
      

    </div>

  )
}))

